import React from 'react';
import LogoImg from './style';

function LogoLogin() {
  return <LogoImg src="/images/logos/SpaDigital_Vetor.png" alt="Spa Digital logo" />;
}

export default LogoLogin;
